import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useFileUploadButtonClassNames } from './hooks/useFileUploadButtonClassNames';
import { useFileUploadButton } from './hooks/useFileUploadButton';
import { FileUploadButtonRoot } from './style';
import { FILEUPLOADBUTTON_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../utils/hooks';
import { Button } from '../Button';
export var FileUploadButton = forwardRef(function FileUploadButton(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(FILEUPLOADBUTTON_CLASS_PREFIX);
  var classNames = useFileUploadButtonClassNames(FILEUPLOADBUTTON_CLASS_PREFIX, className);

  var _useFileUploadButton = useFileUploadButton(props, ref),
      rootProps = _useFileUploadButton.rootProps,
      fileInputProps = _useFileUploadButton.fileInputProps,
      buttonProps = _useFileUploadButton.buttonProps,
      children = _useFileUploadButton.children;

  return React.createElement(FileUploadButtonRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), React.createElement(Button, Object.assign({}, buttonProps, {
    className: classNames.Button
  }), children), React.createElement("input", Object.assign({}, fileInputProps, {
    className: classNames.Input
  })));
});
FileUploadButton.defaultProps = {
  accept: '',
  children: 'Choose file',
  onFileSelect: function onFileSelect() {},
  onClick: function onClick() {},
  primary: true,
  secondary: false,
  tertiary: false,
  danger: false,
  small: false,
  wide: false,
  disabled: false
};